
const dropdownBtn = document.querySelectorAll('.download-dropdown');
const dropdownFiles = document.querySelectorAll('.download-dropdown__files');

if(dropdownBtn) {
    dropdownBtn.forEach((dropdown) => {
        dropdown.addEventListener('click', () => {
            let dropdownId = dropdown.getAttribute('id');

            dropdownFiles.forEach((files) => {
                if (dropdown.classList.contains('--active') && dropdownId == files.getAttribute('id')) {
                    files.classList.add('--hidden');
                    dropdown.classList.remove('--active');
                } else if (!dropdown.classList.contains('--active') && dropdownId == files.getAttribute('id')) {
                    files.classList.remove('--hidden');
                    dropdown.classList.add('--active');
                }
            });
        });
    });
}
